interface SectionHeaderProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
}

/**
 * Reusable SectionHeader component
 * Single responsibility: Display consistent section headers with icons
 */
export function SectionHeader({ icon: Icon, title }: SectionHeaderProps) {
  return (
    <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
      <Icon className="h-4 w-4" />
      <span>{title}</span>
    </div>
  );
}
